import { AuthUser, HttpMethod } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';

export function useUserProfileApi() {
  return useBaseQuery<never, AuthUser>([useUserProfileApi.name], {
    url: '/customer-management/um/users/profile',
    method: HttpMethod.get,
  });
}
